import React from "react";
import "./App.css"; // Import the CSS file for styling

function CorporateCommercialLaw(){

    return <div>

<img src="/supreme-court-of-india.jpg" alt="Header" />
<h2>Corporate Commercial Law , Page Under Construction</h2>


    </div>;


}

export default CorporateCommercialLaw;